import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { HIDE_PRODUCT_CONNECTED_HOME } from 'src/constants/app';
import { BUTTON_CTAS } from 'src/containers/CartPage/constants';
import Button, { THEMES } from 'HTKit/Forms/Button';
import { PanelV2 } from 'src/components/HTKit/Elements/PanelV2';
import { Grid } from 'src/components/HTKit/Grid';
import Icon from 'src/components/HTKit/Icon';
import styles from '../styles.scss';

const BookingCTA = ({ onClick, buttonCta }) => (
  <Button
    onClick={onClick}
    theme={THEMES.V2PRIMARY}
    className={cn('showDesktop initial', styles.ctaButton)}
    hugeV2
  >
    {buttonCta}
  </Button>
);

const BookingPathSelectorBookingPathSelector = ({ onServiceClick, onProductClick }) => {
  const titleStyles = cn('text-weight-med', styles.title);
  const showProductsButton = !HIDE_PRODUCT_CONNECTED_HOME;
  return (
    <Grid.FullWidth classes={styles.container}>
      <Grid.Row classes={styles.customRow}>
        {showProductsButton && (
          <Grid.Column sm={4} md={6} mdOffset={1} lg={6} lgOffset={0}>
            <PanelV2 noShadow largeBorderRadius className={styles.bookingPanel}>
              <div className="paddingBottom-small">
                <Icon name="box" className={cn('paddingRight-small2', styles.icon)} />
              </div>
              <div>
                <h5 className={titleStyles}>Shop for Smart Devices</h5>
                <p className="p1 n700 paddingBottom-small2">
                  Unbeatable prices on smart home devices with expert installation, plus free
                  shipping and returns.
                </p>
              </div>
              <BookingCTA onClick={onProductClick} buttonCta={BUTTON_CTAS.PRODUCTS} />
            </PanelV2>
          </Grid.Column>
        )}
        <Grid.Column sm={4} md={6} mdOffset={1} lg={6} lgOffset={0}>
          <PanelV2 noShadow largeBorderRadius className={styles.bookingPanel}>
            <div className="paddingBottom-small">
              <Icon name="tool" className={cn('paddingRight-small2', styles.icon)} />
            </div>
            <div>
              <h5 className={titleStyles}>Get Installation &amp; Support</h5>
              <p className="p1 n700 paddingBottom-small2">
                Book an expert installation or support service for any connected device in your
                home, with service as soon as today.
              </p>
            </div>
            <BookingCTA onClick={onServiceClick} buttonCta="Book a Service" />
          </PanelV2>
        </Grid.Column>
      </Grid.Row>
    </Grid.FullWidth>
  );
};

BookingPathSelectorBookingPathSelector.propTypes = {
  onServiceClick: PropTypes.func,
  onProductClick: PropTypes.func,
};

BookingCTA.propTypes = {
  onClick: PropTypes.func,
  buttonCta: PropTypes.string,
};

export default BookingPathSelectorBookingPathSelector;
